module.exports = __webpack_public_path__ + "assets/img/EKSElement-back-overview.2926fed6.svg";